module.exports = __webpack_public_path__ + "img/hat-front.1a76bd0d.svg";